/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ScrollView,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import Table from '@components/table/Table';
// import TableMobile from '@components/table/TableMobile';
import ListStickyHeader from '@/screens/catalog/components/ListStickyHeader';
import HeaderRow from '@/screens/catalog/components/HeaderRow';
import BrandLogo from '@/screens/catalog/components/BrandLogo';
import { isWeb, isNative, isAndroid, isMobileWeb } from '@global/screens';
import Colors from '@global/colors';
import useApi from '@/hooks/useApi';
import { MsCatalog } from '@api/ms-catalog';
import { showPopup } from '@/store/modal';
import Toast from 'react-native-toast-message';
import ModalFull from '@components/modal/ModalFull';
import ModalHalf from '@components/modal/ModalHalf';
import * as Layout from '@components/screen/Layout';
import BrandSearch from '@components/form/search/BrandSearch';
import { showAlert } from '@/store/global';
import { paramsReseted } from '@/store/params';
import { exportPdf, capitalizeText } from '@global/helpers';

import PropTypes from 'prop-types';
import Image from '@components/global/Image';

import { exportCsvApi } from '@global/helpers';

const dimension = Dimensions.get('screen');

const propTypes = {
  navigation: PropTypes.object,
  activeTab: PropTypes.string,
  onChangeTab: PropTypes.func,
  mainBanner: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
};

const defaultProps = {
  navigation: {},
  activeTab: 'product',
  onChangeTab: () => {},
  mainBanner: false,
};

const tableStructure = {
  name: {
    head: 'Brand Name',
    body: 'name',
    type: 'slot',
    textStyle: { fontFamily: 'figtree-medium' },
  },
  brand_type: {
    head: 'Brand Type',
    body: 'collaboration_type',
  },
  brand_status: {
    head: 'Brand Status',
    body: 'collaboration_status',
  },
  promotion_type: {
    head: 'Total Products',
    body: 'total_products',
  },
};

let scrollRef = null;

const Brand = (props) => {
  const dispatch = useDispatch();
  const showCatalogExport = useSelector(
    (state) => state.modal.showCatalogExport,
  );
  const { activeTab = 'product', mainBanner, onChangeTab = () => {} } = props;
  const [tableData, setTableData] = useState([]);
  const [tableDataTemp, setTableDataTemp] = useState([]);
  const [letters, setLetters] = useState([]);
  const [letterData, setLetterData] = useState({});
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const showCatalogExportMenu = useSelector(
    (state) => state.modal.showCatalogExportMenu,
  );
  const [exporting, setExporting] = useState(false);
  const [filterExport, setFilterExport] = useState({
    brand: {},
  });

  const getBrandsLetter = useApi(MsCatalog.getBrandsLetter);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      doBrandSearch();
      dispatch(
        showPopup({
          name: 'showCatalogExport',
          value: false,
        }),
      );
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    if (isWeb) {
      const container = document.getElementById('container-web');
      if (container) {
        container.addEventListener('scroll', handleScroll);
      }

      return () => {
        if (container) {
          container.removeEventListener('scroll', handleScroll);
        }
      };
    }
  }, [scrolled]);

  const handleScroll = (e) => {
    if (e?.target?.scrollTop >= 240) {
      if (!scrolled) {
        setScrolled(true);
      }
    } else {
      if (scrolled) {
        setScrolled(false);
      }
    }
  };

  const doBrandSearch = async () => {
    try {
      const response = await getBrandsLetter.request();
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const res = response.data.data;
        setLetterData(res);
        const lets = [];
        const result = [];
        const keys = Object.keys(res);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          lets.push(key);
          result.push({
            name: key,
            total_products: '',
            empty: [
              'collaboration_type',
              'collaboration_status',
              'total_products',
            ],
            style: {
              backgroundColor: Colors.grey4,
            },
            elementId: `letter-${key}`,
            offset: -45,
          });
          if (res[key]?.length) {
            for (let j = 0; j < res[key].length; j++) {
              const item = res[key][j];
              result.push({
                ...item,
                collaboration_type: capitalizeText(item.collaboration_type),
                collaboration_status: capitalizeText(item.collaboration_status),
                style: {
                  backgroundColor: Colors.white,
                },
              });
            }
          }
        }
        setLetters(lets);
        setTableData(result);
        setTableDataTemp(result);
      } else {
        setLetterData([]);
        setLetters([]);
        setTableData([]);
        setTableDataTemp([]);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const doSearch = (val) => {
    const getStrName = (name) => {
      return name?.toLowerCase()?.replace(/[^A-Za-z]/g, '');
    };
    const result = tableDataTemp.filter((a) => {
      return val ? getStrName(a.name)?.includes(getStrName(val)) : true;
    });
    setTableData(result);
  };

  const gotToDetail = (data) => {
    if (data?._id) {
      dispatch(paramsReseted());
      props.navigation.navigate('CatalogBrandScreen', {
        titleScreen: data.name,
        name: data.name,
        id: data._id,
      });
    }
  };

  const onExport = async () => {
    setExporting(true);
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      if (!filterExport.brand?.id) {
        dispatch(
          showAlert({
            show: true,
            title: 'Error',
            description: 'Select Brand To Export',
            isConfirm: false,
          }),
        );
        setExporting(false);
        return;
      }
      const brand = filterExport.brand;
      const payload = { brand: { id: brand.id, name: brand.name } };
      if (brand.id == 'all') {
        delete payload.brand;
      }
      await exportPdf('catalog', brand.id, props.navigation);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      setExporting(false);
    } catch (err) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
      setExporting(false);
    }
  };

  const handleExportCSV = async () => {
    try {
      const payload = {};
      await exportCsvApi('product-export', payload, {
        isDownload: false,
        message: 'Export in progress, the result will be sent to your email.',
      });
    } catch (error) {
      console.log('error-export', error);
    }
  };

  const handleExportReminderInactiveProduct = async () => {
    try {
      await exportCsvApi(
        'reminder-inactive-products',
        {},
        {
          isDownload: false,
          message: 'Export in progress, the result will be sent to your email.',
        },
      );
    } catch (error) {
      console.log('error-export-reminder-inactive-product', error);
    }
  };

  const Header = () => {
    const letterHeight = 44;
    const letterList = [];
    if (letters?.length) {
      let size = isWeb ? 0 : 201;
      for (let i = 0; i < letters.length; i++) {
        const item = letters[i];
        letterList.push({
          label: item,
          size: size,
        });
        size += letterHeight;
        if (letterData[item]?.length) {
          for (let j = 0; j < letterData[item].length; j++) {
            size += letterHeight + (!isWeb ? 11 : 0);
          }
        }
      }
    }

    const goToLetter = (item) => {
      try {
        if (isWeb) {
          document
            .getElementById(`letter-${item.label}`)
            .scrollIntoView({ behavior: 'smooth' });
        } else {
          scrollRef?.scrollTo({
            x: 0,
            y: item.size,
            animated: true,
          });
        }
      } catch (error) {}
    };

    return letterList?.length ? (
      <View style={isWeb ? { minHeight: 38 } : {}}>
        <HeaderRow
          style={[styles.headerWrapper, scrolled ? styles.headerScrolled : {}]}>
          {letterList.map((item, idx) => (
            <TouchableOpacity
              activeOpacity={0.8}
              key={`letter-${idx}`}
              style={styles.headerItem}
              onPress={() => goToLetter(item)}>
              <SociollaText style={{ fontSize: isWeb ? 15 : 14 }}>
                {item.label}
              </SociollaText>
            </TouchableOpacity>
          ))}
        </HeaderRow>
      </View>
    ) : (
      false
    );
  };

  return (
    <>
      {isWeb ? (
        <Table
          name="catalog-screen"
          structures={tableStructure}
          data={tableData}
          loading={loading}
          hasCallback
          hasNoHide
          noRowColor
          rowBottomBorder
          showFilter={false}
          showPagination={false}
          totalData={tableData?.length}
          searchKey="name"
          headerComponent={{
            colSpan: 2,
            component: <Header />,
          }}
          searchPlaceholder="Search by name..."
          slot={{
            name: ({ data, index }) => (
              <View
                key={index}
                style={{ flexDirection: 'row', alignItems: 'center' }}>
                {data?._id ? (
                  <BrandLogo url={data.logo} style={{ marginRight: 10 }} />
                ) : (
                  false
                )}
                <SociollaText type="medium" style={{ fontSize: 14 }}>
                  {data.name}
                </SociollaText>
              </View>
            ),
          }}
          onClickRow={({ data }) => gotToDetail(data)}
          onSearch={(value) => doSearch(value)}
          moreInlineFilter={
            <>
              <Button
                type="primary"
                rounded={true}
                buttonStyle={{ width: 90 }}
                title={
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, color: Colors.white }}>
                    Export CSV
                  </SociollaText>
                }
                onPress={() => handleExportCSV()}
                style={{ marginRight: 8 }}
              />
              <Button
                type="primary"
                rounded={true}
                buttonStyle={{ width: 230 }}
                title={
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, color: Colors.white }}>
                    Export Reminder Inactive Product
                  </SociollaText>
                }
                onPress={() => handleExportReminderInactiveProduct()}
                style={{ marginRight: 8 }}
              />
              <Button
                type="primary"
                rounded={true}
                buttonStyle={{ width: 42 }}
                title={
                  <View style={{ flexDirection: 'row' }}>
                    <Image
                      style={{
                        width: 13,
                        height: 17,
                      }}
                      width={13}
                      height={17}
                      source={require('@assets/img/icons/pdf.png')}
                    />
                  </View>
                }
                onPress={() =>
                  dispatch(
                    showPopup({
                      name: 'showCatalogExport',
                      value: true,
                    }),
                  )
                }
              />
            </>
          }
        />
      ) : (
        <ListStickyHeader
          scrollRef={(val) => (scrollRef = val)}
          searchKey="name"
          placeholder="Search by name"
          loading={loading}
          onSearch={(value) => doSearch(value)}
          data={tableData}
          headerSticky={<Header />}
          activeTab={activeTab}
          onChangeTab={(val) => onChangeTab(val)}
          mainBanner={mainBanner}
          renderItem={({ data, index }) => (
            <TouchableOpacity
              activeOpacity={0.6}
              style={[styles.brandItem, data.style]}
              onPress={() => gotToDetail(data)}
              key={index}>
              <View style={styles.brandItemInfo}>
                <SociollaText type="medium" style={{ fontSize: 14 }}>
                  {data.name ? data.name : '-'}
                </SociollaText>
                {data?._id &&
                (data.collaboration_type || data.collaboration_status) ? (
                  <SociollaText style={styles.brandItemMeta}>
                    {`${data.collaboration_type || '-'} | ${
                      data.collaboration_status || '-'
                    }`}
                  </SociollaText>
                ) : (
                  false
                )}
              </View>
              {data?._id ? <BrandLogo url={data.logo} /> : false}
            </TouchableOpacity>
          )}
        />
      )}
      <ModalHalf
        title="Export"
        noTranslate={true}
        visible={showCatalogExportMenu}
        onClose={() =>
          dispatch(showPopup({ name: 'showCatalogExportMenu', value: false }))
        }
        maxWidth={'100%'}
        headerBordered>
        <TouchableOpacity
          style={styles.exportMenuItem}
          activeOpacity={0.8}
          onPress={() => {
            dispatch(
              showPopup({ name: 'showCatalogExportMenu', value: false }),
            );
            handleExportCSV();
          }}>
          <SociollaText style={styles.exportMenuText}>Export CSV</SociollaText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.exportMenuItem}
          activeOpacity={0.8}
          onPress={() => {
            dispatch(
              showPopup({ name: 'showCatalogExportMenu', value: false }),
            );
            dispatch(showPopup({ name: 'showCatalogExport', value: true }));
          }}>
          <SociollaText style={styles.exportMenuText}>Export PDF</SociollaText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.exportMenuItem}
          activeOpacity={0.8}
          onPress={() => {
            dispatch(
              showPopup({ name: 'showCatalogExportMenu', value: false }),
            );
            handleExportReminderInactiveProduct();
          }}>
          <SociollaText style={styles.exportMenuText}>
            Export Reminder Inactive Product
          </SociollaText>
        </TouchableOpacity>
      </ModalHalf>
      <ModalFull
        title="Export Catalog"
        noTranslate={true}
        show={showCatalogExport}
        onClose={() =>
          dispatch(
            showPopup({
              name: 'showCatalogExport',
              value: false,
            }),
          )
        }>
        <View
          style={{
            height: isWeb
              ? 'calc(100vh - 150px)'
              : dimension.height - (isAndroid ? 140 : 110),
          }}>
          <ScrollView contentContainerStyle={{ width: '100%' }}>
            <Layout.FormWrapper style={{ padding: 15, height: '100%' }}>
              <Layout.FormGroup lastItem>
                <SociollaText style={{ fontSize: 13, marginBottom: 10 }}>
                  Brands
                </SociollaText>
                <BrandSearch
                  hideLabel={true}
                  isRequired
                  value={filterExport.brand}
                  allBrand={true}
                  onChange={(value) => {
                    setFilterExport({ brand: value });
                  }}
                />
              </Layout.FormGroup>
            </Layout.FormWrapper>
          </ScrollView>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'flex-end',
              justifyContent: isWeb ? 'end' : 'space-between',
              paddingVertical: isWeb ? 20 : 15,
              paddingHorizontal: isWeb ? 20 : 15,
              backgroundColor: Colors.white,
              ...(!isWeb
                ? {
                    position: isMobileWeb ? 'fixed' : 'absolute',
                    bottom: 0,
                    right: 0,
                    left: 0,
                  }
                : {}),
            }}>
            <Button
              rounded={true}
              type="primary"
              buttonStyle={{
                width: isWeb
                  ? 100
                  : dimension.width / 2 - (isMobileWeb ? 20 : 25),
                backgroundColor: Colors.white,
                marginRight: 10,
              }}
              title={
                <SociollaText type="medium" style={{ fontSize: 14 }}>
                  Cancel
                </SociollaText>
              }
              onPress={() =>
                dispatch(
                  showPopup({
                    name: 'showCatalogExport',
                    value: false,
                  }),
                )
              }
            />
            <Button
              rounded={true}
              type="primary"
              buttonStyle={{
                width: isWeb
                  ? 100
                  : dimension.width / 2 - (isMobileWeb ? 20 : 25),
              }}
              disabledStyle={{ width: 90 }}
              disabled={exporting}
              title={
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.white }}>
                  {exporting ? 'Loading...' : 'Export'}
                </SociollaText>
              }
              onPress={() =>
                onExport().then(() => {
                  dispatch(
                    showPopup({
                      name: 'showCatalogExport',
                      value: false,
                    }),
                  );
                })
              }
            />
          </View>
        </View>
      </ModalFull>
    </>
  );
};

Brand.propTypes = propTypes;
Brand.defaultProps = defaultProps;

const styles = StyleSheet.create({
  brandItem: {
    width: '100%',
    paddingVertical: 13,
    paddingHorizontal: 10,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  brandItemInfo: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: 10,
  },
  brandItemMeta: {
    fontSize: 12,
    color: Colors.grey2,
    marginTop: 4,
  },
  exportMenuItem: {
    paddingVertical: 16,
    paddingHorizontal: 15,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  exportMenuText: {
    fontSize: 14,
    color: Colors.black1,
  },
  headerItem: {
    paddingVertical: isWeb ? 10 : 15,
    paddingHorizontal: isWeb ? 0 : 10,
    ...(isWeb
      ? {
          width: 'calc(100% / 16.5)',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }
      : {}),
  },
  headerWrapper: {
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  headerScrolled: {
    position: isNative ? 'absolute' : 'fixed',
    top: 55,
    right: 30,
    left: 30,
    width: 'calc(100% - 60px)',
    zIndex: 2,
    elevation: 2,
  },
});

export default React.memo(Brand, (prev, next) => prev == next);
